module.exports = __webpack_public_path__ + "static/media/icon_businessNotConnected.b67a3c3d.svg";